import React, { useState, useEffect, useRef } from 'react';
import styles from './Support.module.css';
import { BiSupport } from "react-icons/bi";
import { connect } from 'react-redux';
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';


const Support = (props) => {
  const [showSupport, setShowSupport] = useState(false);

  const supportRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (supportRef.current && !supportRef.current.contains(event.target)) {
        setShowSupport(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [supportRef]);

  if (props.user.type === 'User' || props.user.type === 'Customer') {
    return (
      <div className={styles.support} ref={supportRef}>
        <div className={`${styles['support-block']} ${showSupport ? styles.show : ''}`}>
          <div className={styles.head}>
            Need Help?
            <button onClick={() => setShowSupport(false)} className={styles['button-close']}>x</button>
          </div>

          <div className={styles['support-body-container']}>
            <div className={styles['support-body']}>
             {false && <div className={styles['with-space']} >

              Check out our User Guide for quick how-tos and FAQs
              <div  >

                  <Link to="/userguide" className="userguide-link">
                    View User Guide <FaExternalLinkAlt />
                  </Link>
                </div>
              </div>}

              <div className={styles['with-space']} >

              {/* { <b>Still need help ?</b> } */}
              <b>We're here for you!</b>
              
              <div  >
              Email us at
              <br/>
                <a href="mailto:info@breathe-ev.com">info@breathe-ev.com</a>
              </div>
              Or
              <div  >
               give us a call at
              <br/>
                <a href="tel:+18442522083">+1 (877) 367-1001</a>
              </div>
             </div>
            </div>
          </div>

          <div className={styles['support-bottom']}>We'll get back to you as soon as possible!</div>
        </div>
        <button onClick={() => setShowSupport(!showSupport)} className={styles['btn-support']}><BiSupport /></button>
      </div>
    );
  }
  else {
    return <></>
  }

};

const mapStateToProps = state => ({
  user: state.auth && state.auth.user ? state.auth.user : null,
});

export default connect(mapStateToProps)(Support);